import { hiddenGems } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function HiddenGems() {
  return (
    <section id="gems" className="bg-secondary-50 border-y border-secondary-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="冷门宝藏"
          title="没什么热度，但看完想立刻安利的好片"
          desc="这一栏专门留给评分不错却容易被忽略的作品，题材偏文艺与家庭，适合安静的时候慢慢看。"
        />

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {hiddenGems.map((item) => (
            <article
              key={item.id}
              className="flex items-start gap-4 rounded-xl border border-secondary-200 bg-background-50 p-5 transition hover:border-secondary-400"
            >
              <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                <i className="ri-vip-diamond-line text-xl"></i>
              </span>
              <div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <p className="mt-3 text-xs text-foreground-500">
                  {item.region} · {item.year}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}